/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListShadowMCPInventoryServersForUserRequest,
  ListShadowMCPInventoryServersForUserSecurity,
} from "../models/operations/listshadowmcpinventoryserversforuser.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildShadowMCPInventoryServersForUserQuery,
  prefetchShadowMCPInventoryServersForUser,
  queryKeyShadowMCPInventoryServersForUser,
  ShadowMCPInventoryServersForUserQueryData,
} from "./shadowMCPInventoryServersForUser.core.js";
export {
  buildShadowMCPInventoryServersForUserQuery,
  prefetchShadowMCPInventoryServersForUser,
  queryKeyShadowMCPInventoryServersForUser,
  type ShadowMCPInventoryServersForUserQueryData,
};

export type ShadowMCPInventoryServersForUserQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listShadowMCPInventoryServersForUser access
 *
 * @remarks
 * List the Shadow MCP servers one person reached, with each server's access state. The inverse of listShadowMCPInventoryUsers, which expands a single server into its users.
 */
export function useShadowMCPInventoryServersForUser(
  request: ListShadowMCPInventoryServersForUserRequest,
  security?: ListShadowMCPInventoryServersForUserSecurity | undefined,
  options?: QueryHookOptions<
    ShadowMCPInventoryServersForUserQueryData,
    ShadowMCPInventoryServersForUserQueryError
  >,
): UseQueryResult<
  ShadowMCPInventoryServersForUserQueryData,
  ShadowMCPInventoryServersForUserQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildShadowMCPInventoryServersForUserQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listShadowMCPInventoryServersForUser access
 *
 * @remarks
 * List the Shadow MCP servers one person reached, with each server's access state. The inverse of listShadowMCPInventoryUsers, which expands a single server into its users.
 */
export function useShadowMCPInventoryServersForUserSuspense(
  request: ListShadowMCPInventoryServersForUserRequest,
  security?: ListShadowMCPInventoryServersForUserSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ShadowMCPInventoryServersForUserQueryData,
    ShadowMCPInventoryServersForUserQueryError
  >,
): UseSuspenseQueryResult<
  ShadowMCPInventoryServersForUserQueryData,
  ShadowMCPInventoryServersForUserQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildShadowMCPInventoryServersForUserQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setShadowMCPInventoryServersForUserData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      projectId: string;
      userKeys: Array<string>;
      from?: Date | undefined;
      to?: Date | undefined;
      limit?: number | undefined;
      gramSession?: string | undefined;
    },
  ],
  data: ShadowMCPInventoryServersForUserQueryData,
): ShadowMCPInventoryServersForUserQueryData | undefined {
  const key = queryKeyShadowMCPInventoryServersForUser(...queryKeyBase);

  return client.setQueryData<ShadowMCPInventoryServersForUserQueryData>(
    key,
    data,
  );
}

export function invalidateShadowMCPInventoryServersForUser(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      projectId: string;
      userKeys: Array<string>;
      from?: Date | undefined;
      to?: Date | undefined;
      limit?: number | undefined;
      gramSession?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "access",
      "listShadowMCPInventoryServersForUser",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllShadowMCPInventoryServersForUser(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "access",
      "listShadowMCPInventoryServersForUser",
    ],
  });
}
